import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Input, Row } from "reactstrap";
import { Triangle } from "react-loader-spinner";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import Select from "react-select";
import CategoryServices from "../../../services/OrderingServices/CategoryService";
import SalesReportService from "../../../services/OrderingServices/SalesReportService";
// import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import PieChart from "../../../Components/Common/Piechart";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const ItemPercentDetailReport = ({ categoryData }) => {
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const formatDate = (date) => date?.toLocaleDateString("en-CA");

  // Fetch report data
  const fetchData = async (
    from = fromDate,
    to = toDate,
    category = selectedCategory
  ) => {
    if (!from || !to) return;

    setLoading(true);
    try {
      const response = await SalesReportService.itemPercent({
        categoryId: category?.value || null,
        fromDate: formatDate(from),
        toDate: formatDate(to),
      });
      setAllData(response || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
    } finally {
      setLoading(false);
    }
  };

  // Initialize 1-month range on mount + fetch data
  useEffect(() => {
    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(today.getMonth() - 1);

    setFromDate(lastMonth);
    setToDate(today);

    // fetchCategoryData();
    fetchData(lastMonth, today, null); // fetch all categories initially
  }, []);

  // Auto-fetch whenever category changes
  useEffect(() => {
    if (fromDate && toDate) {
      fetchData(fromDate, toDate, selectedCategory);
    }
  }, [selectedCategory]);

  // totals
  const totalSales = allData.reduce((sum, item) => sum + item.totalSales, 0);
  const totalPercent = allData.reduce(
    (sum, item) => sum + item.percentageOfOverallSales,
    0
  );

  const categoryOption = categoryData?.map((item) => ({
    value: item.id,
    label: item.name,
  }));
  const breadcrumbItems = [{ title: "Back To List ", link: "/sales-report/wise" }];

  return (
    <div className="page-content">
      <div class="container-fluid">
        <BreadCrumb
          pageTitle="Stock Summary"
          title="Percent Wise Item Report"
          breadcrumbItems={breadcrumbItems}
        />
        <Card className="shadow-sm mb-4">
          <CardBody>
            {/* Filters */}
            <Row className="mb-4 align-items-end">
              <Col md={4} className="mb-2">
                <Select
                  isClearable
                  options={categoryOption}
                  value={selectedCategory}
                  onChange={setSelectedCategory}
                  placeholder="Filter by Category"
                  className="fs-6"
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </Col>
              <Col md={2} className="mb-2">
                <Flatpickr
                  options={{ dateFormat: "Y-m-d" }}
                  value={fromDate}
                  onChange={(dates) => setFromDate(dates[0])}
                  className="form-control"
                  placeholder="From Date"
                />
              </Col>
              <Col md={2} className="mb-2">
                <Flatpickr
                  options={{ dateFormat: "Y-m-d" }}
                  value={toDate}
                  onChange={(dates) => setToDate(dates[0])}
                  className="form-control"
                  placeholder="To Date"
                />
              </Col>
              <Col md={2} className="mb-2">
                <Button
                  color="primary"
                  className="w-100"
                  onClick={() => fetchData()}
                >
                  Generate
                </Button>
              </Col>
            </Row>

            {/* Loader */}
            {loading ? (
              <div className="my-5 text-center d-flex flex-column align-items-center">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
                <h5 className="mt-3">Loading...</h5>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                  <thead className="table-primary sticky-top">
                    <tr>
                      <th>SN</th>
                      <th>Item Name</th>
                      <th className="text-end">Overall Percentage</th>
                      <th className="text-end">Total Sales</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allData.length > 0 ? (
                      allData.map((item, index) => (
                        <tr key={`${item.categoryId}-${item.itemName}`}>
                          <td>{index + 1}</td>
                          <td>{item.itemName}</td>
                          <td className="text-end">
                            {item.percentageOfOverallSales}
                          </td>
                          <td className="text-end">
                            <NumberWithCommas number={item.totalSales} />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                  {allData.length > 0 && (
                    <tfoot>
                      <tr className="table-secondary fw-bold text-end">
                        <td colSpan="2">Total</td>
                        <td>{Math.round(totalPercent)}%</td>
                        <td>
                          <NumberWithCommas number={totalSales} />
                        </td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            )}
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default ItemPercentDetailReport;
